import { N8N_TEAMS_URL } from '@/api/n8n'

export interface MacroExecutionEntry {
  macroId: string
  macroName: string
  conversationId: number
  actionName: string
  actionLabel: string
  ok: boolean
  msg: string
  executedById?: number | string | null
  executedByName?: string | null
}

export interface MacroExecutionLogRow extends MacroExecutionEntry {
  id: number
  executedAt: number // epoch seconds
}

/**
 * Registra a execução de uma ação de macro (ver migrations/admin-mysql-migration-v11.sql).
 * Fire-and-forget de propósito, como slaService.notifySLA(): nunca deve travar nem quebrar
 * a execução real da macro por falha de rede/log, então engole qualquer erro silenciosamente.
 */
export function logMacroExecution(token: string, entry: MacroExecutionEntry): void {
  try {
    const p = fetch(N8N_TEAMS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ command: 'log_macro_execution', timestamp: Date.now(), access_token: token, ...entry }),
    })
    if (p && typeof p.catch === 'function') p.catch(() => { /* silencioso */ })
  } catch { /* silencioso */ }
}

export interface MacroExecutionLogFilters {
  macroId?: string
  conversationId?: number
  limit?: number
}

export async function fetchMacroExecutionLog(token: string, filters: MacroExecutionLogFilters = {}): Promise<MacroExecutionLogRow[]> {
  const res = await fetch(N8N_TEAMS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ command: 'list_macro_executions', timestamp: Date.now(), access_token: token, ...filters }),
  })
  if (!res.ok) throw new Error(`Erro ${res.status} ao buscar histórico de execuções de macro`)
  const data = await res.json()
  const rows: Record<string, unknown>[] = Array.isArray(data) ? data : []
  return rows.map(r => ({
    id:             Number(r.id),
    macroId:        String(r.macro_id),
    macroName:      String(r.macro_name ?? ''),
    conversationId: Number(r.conversation_id),
    actionName:     String(r.action_name ?? ''),
    actionLabel:    String(r.action_label ?? ''),
    ok:             Number(r.ok) === 1,
    msg:            String(r.msg ?? ''),
    executedById:   (r.executed_by_id as number | string | null) ?? null,
    executedByName: (r.executed_by_name as string | null) ?? null,
    executedAt:     Number(r.executed_at),
  }))
}
